import { render } from "./Restau.vue?vue&type=template&id=2d6c1398&scoped=true"
import script from "./Restau.vue?vue&type=script&lang=ts"
export * from "./Restau.vue?vue&type=script&lang=ts"

import "./Restau.vue?vue&type=style&index=0&id=2d6c1398&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d6c1398"

export default script